// src/utils/projectStatus.js

export const getProjectProgress = (project) => {
    const sections = Array.isArray(project.sections) ? project.sections : [];
    const totalSections = sections.length;

    const translatedArr = Array.isArray(project.translatedSections)
        ? project.translatedSections
        : [];
    const translatedCount = translatedArr.filter((t) => t && t.trim().length > 0).length;

    return totalSections > 0 ? Math.floor((translatedCount / totalSections) * 100) : 0;
};

export const getProjectStatus = (project) => {
    const sections = Array.isArray(project.sections) ? project.sections : [];
    const totalSections = sections.length;

    const translatedArr = Array.isArray(project.translatedSections)
        ? project.translatedSections
        : [];
    const translatedCount = translatedArr.filter((t) => t && t.trim().length > 0).length;

    const approvedArr = Array.isArray(project.approvedSections)
        ? project.approvedSections
        : [];
    const approvedCount = approvedArr.length;

    if (totalSections === 0) {
        return 'in progress';
    }
    if (approvedCount === totalSections) {
        return 'complete';
    }
    if (translatedCount === totalSections) {
        return 'translated';
    }
    return 'in progress';
};

export const statusColor = {
    'in progress': 'primary',
    translated: 'warning',
    complete: 'success',
};

